import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import negatifImg from '../images/NEGATIF.svg';
import negativeImg from '../images/NEGATIVE-2.svg';
import equivocalImg from '../images/NOTCLEAR.svg';
import equivoqueImg from '../images/PASCLAIR.svg';
import positifImg from '../images/POSITIF.svg';
import positiveImg from '../images/POSITIVE.svg';
import aucunresult from '../images/RESULTATPASENCOREREVENU.svg';
import noresult from '../images/RESULTSNOTINYET.svg';

import { formatDate } from '../util/util';

import { EQUIVOCAL, NEGATIVE, PENDING, POSITIVE } from '../api/mappers/labResultMapper';

import { LANG_EN, LANG_FR } from '../util/language';

const RecentResult = (props) => {
    const classes = useStyles();

    const renderDate = () => {
        if (props.result === PENDING) {
            return null;
        } else {
            return (
                <li class="list-group-item d-flex justify-content-between align-items-center">
                    {props.strings.RECENT_RESULTS_COMPLETED}
                    <span class="badge">{formatDate(props.date, props.language)}</span>
                </li>
            );
        }
    }

    //<span class="badge badge-green badge-pill">{formatResult(props.result, props.strings)}</span>
    return (
        <div className="row">
            <div className="col-12 col-md-5 col-lg-4">
                <div class="circle"><img src={getImage(props.result, props.language)} width="60%" /></div>
            </div>
            <div className="col-12 col-md-7 col-lg-8 ml-auto">
                <div className="section">
                    <ul class="list-group">
                        {renderDate()}
                        <li class="list-group-item d-flex justify-content-between align-items-center">
                            {props.strings.RESULTS_TAG}
                            <span class="badge badge-green badge-pill">{formatResult(props.result, props.strings)}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default RecentResult;

function formatResult(result, strings) {
    if (result === POSITIVE ) {
        return strings.TEST_POSITIVE;
    } else if (result === NEGATIVE) {
        return strings.TEST_NEGATIVE;
    } else if (result === EQUIVOCAL) {
        return strings.TEST_EQUIVOCAL;
    } else {
        return strings.TEST_PENDING;
    }
}

// FIXME Requires pending/unknown image.
function getImage(result, lang) {
  let img = noresult;
  if (lang == LANG_FR) {
      img = aucunresult;
  }
  if (result === POSITIVE ) {
      if (lang == LANG_EN) {
          img = positiveImg;
      } else {
          img = positifImg;
      }
  } else if (result === NEGATIVE) {
    if (lang == LANG_EN) {
        img = negativeImg;
    } else {
        img = negatifImg;
    }
  } else if (result === EQUIVOCAL) {
    if (lang === LANG_EN) {
        img = equivocalImg;
    } else {
        img = equivoqueImg;
    }
  }
  return img;
}

const useStyles = makeStyles(theme => ({
    icon: {
        fontSize: 30
    },
    info: {
        display: "flex",
        flexGrow: 1,
        width: 326,
        alignContent: "center"
    },
    resultsImg: {
        width: 200,
        height: 200,
        paddingRight: 15
    },
    row: {
        verticalAlign: 'middle',
        display: 'inline-block',
    }
}));
